export class NotificationSetting {
    public Notify:number;
    public NotificationEmail:string
    
    constructor(){
        this.Notify = 0;
    }
}
